export default __webpack_public_path__ + "static/media/duster-techroad-medium1.be79688c.jpg";